import styled from '@emotion/styled';

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #727272;
  line-height: 150%;
`;
